const API_BASE = '/api';

export function getApiBase() {
  return API_BASE;
}

export async function request(path, options = {}) {
  const url = `${API_BASE}${path}`;
  const config = {
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    ...options,
  };

  const res = await fetch(url, config);

  if (!res.ok) {
    let errorMsg = `Request failed: ${res.status}`;
    try {
      const data = await res.json();
      errorMsg = data.error || errorMsg;
    } catch { /* non-JSON error response (e.g. nginx 502 HTML) */ }
    throw new Error(errorMsg);
  }

  return res.json();
}
